export const heroStats = [
  { number: '500+', label: 'Verified Consultancies' },
  { number: '50,000+', label: 'Students Placed Abroad' },
  { number: '30+', label: 'Destination Countries' },
];

export const studentFeatures = [
  {
    icon: 'MapPin',
    title: 'Find Nearby Consultancies',
    description: 'Discover top-rated education consultancies around you. View profiles, services, and reviews.',
  },
  {
    icon: 'CalendarCheck',
    title: 'Book Appointments Instantly',
    description: 'Pick a date and time that works for you. Confirm your slot in under 60 seconds.',
  },
  {
    icon: 'BotMessageSquare',
    title: 'AI Guidance 24/7',
    description: 'Ask our AI anything — visa requirements, course options, scholarship tips, or destination advice.',
  },
  {
    icon: 'Bell',
    title: 'Real-Time Notifications',
    description: 'Never miss an update. Get alerts for appointment reminders, application status, and counselor messages.',
  },
];

export const consultancyFeatures = [
  {
    icon: 'Users',
    title: 'Student CRM',
    description: 'Track every student from first enquiry to final visa. Full history, notes, and status updates in one view.',
  },
  {
    icon: 'UserCheck',
    title: 'Counselor Management',
    description: 'Add counselors, assign students, track performance, and manage workloads — all from your dashboard.',
  },
  {
    icon: 'TrendingUp',
    title: 'Lead Pipeline',
    description: 'Never lose a lead. Capture walk-ins, referrals, and online enquiries. Schedule follow-ups automatically.',
  },
  {
    icon: 'ClipboardList',
    title: 'Attendance & Leave',
    description: 'Monitor daily attendance, approve leave requests, and generate monthly reports with one click.',
  },
  {
    icon: 'CalendarDays',
    title: 'Appointment Calendar',
    description: 'View all appointments across your team. Book, reschedule, or cancel with an intuitive calendar.',
  },
  {
    icon: 'BarChart3',
    title: 'Performance Reports',
    description: 'See conversion rates, counselor performance, and student pipeline analytics in visual dashboards.',
  },
];

export const howItWorksSteps = [
  {
    step: '01',
    title: 'Consultancy Signs Up',
    description: 'Create your free EzyAbroad account in minutes. Set up your profile, add your team, and customise your service offerings.',
  },
  {
    step: '02',
    title: 'Students Discover You',
    description: 'Students find your consultancy through the EzyAbroad app using location-based search. They view your profile and book appointments.',
  },
  {
    step: '03',
    title: 'Manage & Convert',
    description: 'Track every student interaction in your dashboard. Assign counselors, log notes, and manage the journey from lead to visa approval.',
  },
];

export const tabStudentFeatures = [
  { icon: 'Search', title: 'Smart Search', description: 'Find consultancies by country, city, university, or visa type. Results ranked by rating and distance.' },
  { icon: 'Star', title: 'Verified Reviews', description: 'Read genuine reviews from students who have used the consultancy. Make informed decisions.' },
  { icon: 'MessageSquare', title: 'In-App Messaging', description: 'Chat directly with your assigned counselor inside the app. No need to hunt for a phone number.' },
  { icon: 'FileText', title: 'Document Checklist', description: 'Know exactly which documents you need for each country. AI-generated personalised checklists.' },
  { icon: 'Globe', title: 'Country Guides', description: 'Detailed guides for UK, USA, Canada, Australia, Germany, and 25+ other destinations.' },
  { icon: 'Sparkles', title: 'AI Study Advisor', description: 'Our AI answers your study abroad questions instantly — visas, costs, rankings, deadlines, and more.' },
];

export const tabConsultancyFeatures = [
  { icon: 'LayoutDashboard', title: 'Unified Dashboard', description: 'All your KPIs, tasks, and team updates in a single, clean view. Know your business at a glance.' },
  { icon: 'Users', title: 'Team Management', description: 'Add unlimited counselors (on Premium), assign roles, set permissions, and monitor activity.' },
  { icon: 'Kanban', title: 'Lead Kanban Board', description: 'Drag-and-drop lead management. See your full pipeline from first contact to visa approval.' },
  { icon: 'PhoneCall', title: 'Call Logs', description: 'Log every call with a student or lead. Notes are saved to their profile automatically.' },
  { icon: 'FileBarChart', title: 'Export Reports', description: 'Download attendance, performance, and conversion reports as PDF or Excel — in one click.' },
  { icon: 'Bell', title: 'Smart Reminders', description: 'Automated follow-up reminders so no lead goes cold and no appointment gets missed.' },
];

export const pricingPlans = [
  {
    name: 'Basic',
    badge: null,
    price: '2,999',
    billingNote: 'or 29,999/year (save 17%)',
    for: 'Small consultancies just getting started',
    maxCounselors: 'Up to 5 Counselors',
    maxStudents: 'Up to 100 Students',
    includes: ['Student CRM', 'Attendance & Leave', 'Appointment Calendar', 'Basic Reports'],
    excludes: ['Lead Pipeline', 'AI Chat', 'Advanced Analytics'],
    cta: 'Start Free Trial',
    ctaLink: '/consultancy/register?plan=basic',
    highlighted: false,
  },
  {
    name: 'Pro',
    badge: 'Most Popular',
    price: '6,999',
    billingNote: 'or 69,999/year (save 17%)',
    for: 'Growing consultancies with active lead pipelines',
    maxCounselors: 'Up to 15 Counselors',
    maxStudents: 'Up to 500 Students',
    includes: ['Everything in Basic', 'Lead Pipeline', 'Follow-ups', 'Call Logs', 'AI Chat', 'Advanced Reports'],
    excludes: ['Priority Support', 'Advanced Finance Reports'],
    cta: 'Start Free Trial',
    ctaLink: '/consultancy/register?plan=pro',
    highlighted: true,
  },
  {
    name: 'Premium',
    badge: null,
    price: '12,999',
    billingNote: 'or 1,29,999/year (save 17%)',
    for: 'Large or multi-branch consultancy operations',
    maxCounselors: 'Unlimited Counselors',
    maxStudents: 'Unlimited Students',
    includes: ['Everything in Pro', 'Priority Support', 'Multi-branch', 'Custom Reports', 'Early Access to New Features'],
    excludes: [],
    cta: 'Contact Sales',
    ctaLink: '#contact',
    highlighted: false,
  },
];

export const testimonials = [
  {
    quote: 'EzyAbroad completely transformed how we manage students. What used to take our team 3 hours a day now takes 20 minutes.',
    name: 'Rajesh Sharma',
    role: 'Director, Global Dreams Overseas',
    location: 'Hyderabad, India',
    stars: 5,
  },
  {
    quote: 'The lead pipeline feature alone is worth the subscription. We went from losing leads to converting 70% of them in under 3 months.',
    name: 'Priya Menon',
    role: 'Senior Education Counselor, StudyPath Consultancy',
    location: 'Bangalore, India',
    stars: 5,
  },
  {
    quote: 'I found my consultancy through EzyAbroad, booked an appointment the same day, and my visa got approved 4 months later. Life-changing!',
    name: 'Ananya Reddy',
    role: 'Student, now studying at University of Melbourne',
    location: 'Visakhapatnam, India',
    stars: 5,
  },
];

export const contactInfo = [
  { icon: 'Mail', label: 'Email', value: 'hello@ezyabroad.com' },
  { icon: 'Phone', label: 'Phone', value: '+91 98765 43210' },
  { icon: 'MessageCircle', label: 'WhatsApp', value: '+91 98765 43210' },
  { icon: 'MapPin', label: 'Office', value: 'Hyderabad, Telangana, India' },
];

export const footerQuickLinks = [
  { label: 'Home', href: '/#hero' },
  { label: 'About Us', href: '/#how-it-works' },
  { label: 'Features', href: '/#features' },
  { label: 'Pricing', href: '/#pricing' },
  { label: 'Contact', href: '/#contact' },
  { label: 'Privacy Policy', href: '/privacy' },
  { label: 'Terms of Service', href: '/terms' },
  { label: 'Blog', href: '/blog' },
];

export const footerConsultancyLinks = [
  { label: 'Login to Dashboard', href: '/consultancy/login' },
  { label: 'Create Free Account', href: '/consultancy/register' },
  { label: 'Pricing', href: '/#pricing' },
  { label: 'Help & Support', href: '/support' },
  { label: 'API Documentation', href: '/docs' },
];
